import * as React from "react";
import { Route } from "react-router";

export type RouteType = {
  path: string;
  component: React.ComponentType<any>;
  routes?: RouteType[];
  name?: string;
  exact?: boolean;
};
export type RouteComponentType = RouteType & { [p in string]: any };

export const RouteWithSubRoutes = (route: RouteComponentType) => (
  <Route
    exact={route.exact}
    path={route.path}
    render={(props) => {
      if (route.component) {
        return <route.component {...props} {...route} />;
      } else {
        window.location.href = route.path;
        return null;
      }
    }}
  />
);
